/**
 * Klavye kısayolu kuralları (CLOS-100 `[061]`).
 *
 * ### Neden saf fonksiyon
 *
 * Kartın kritik kriteri bir OLUMSUZLAMA: *"kısayol form alanlarında, editörde veya sistem
 * kısayoluyla çakışan bağlamda uygunsuz çalışmaz."* Bir bileşenin `useEffect`'ine gömülü
 * `if` ancak dolaylı olarak ölçülebilirdi; burada her koşul tek tek sınanıyor.
 *
 * Sonraki kısayollar (`[062]` Yeni Sözleşme dahil) aynı kapıdan geçmeli — kural iki yerde
 * yazılırsa biri gevşer ve kullanıcı yazarken kısayola yakalanır.
 */

/** Değiştirici tuş kombinasyonu Ctrl+K ya da Command+K mı? */
export function isSearchHotkey(event: KeyboardEvent): boolean {
  /**
   * ⚠ `key` VAR SAYILAMAZ — canlı üründe ölçüldü. Hesap ve Güvenlik ekranında konsola iki
   * kez `TypeError: … (reading 'toLowerCase')` düşüyordu; `document.dispatchEvent(new
   * Event("keydown"))` aynı hatayı birebir üretti. Olayı uygulama kodu yaymıyor: `key`
   * alanı olmayan bir keydown, şifre yöneticisi, tarayıcı eklentisi ya da bazı sanal
   * klavyeler tarafından yayılabiliyor ve tip imzası (`KeyboardEvent`) bunu engellemiyor —
   * imza derleme zamanının sözü, olay çalışma zamanının gerçeği.
   *
   * Sonuç kullanıcının hiçbir tuşa basmadığı anda yakalanmamış bir istisnaydı.
   */
  if (typeof event.key !== "string") return false;
  if (event.key.toLowerCase() !== "k") return false;
  /**
   * ⚠ Shift ve Alt DIŞLANIYOR. Ctrl/Cmd+Shift+K tarayıcı konsolunu açar; onu ele geçirmek
   * geliştirici aracını çalınmış gösterirdi — kartın *"sistem kısayoluyla çakışan bağlamda
   * uygunsuz çalışmaz"* kriteri.
   */
  if (event.shiftKey || event.altKey) return false;
  return event.ctrlKey || event.metaKey;
}

const DUZENLENEBILIR_ETIKETLER = new Set(["INPUT", "TEXTAREA", "SELECT"]);

/**
 * Hedef, kullanıcının YAZDIĞI bir bağlam mı?
 *
 * Kapsam bilerek GENİŞ: onay kutusu da `INPUT`. Bir formun içindeki kullanıcı "yazma
 * kipinde"dir ve onu oradan koparan bir kısayol, kriterin adlandırdığı hatanın ta kendisi.
 * Dar bir liste (yalnız `type="text"`) her yeni input türünde yeniden gözden geçirilmeyi
 * gerektirirdi.
 */
export function isEditableTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  if (DUZENLENEBILIR_ETIKETLER.has(target.tagName)) return true;
  /**
   * Zengin metin editörü (sözleşme ekranlarıyla gelecek) DOM'da `contenteditable` olarak
   * görünür. `isContentEditable` tarayıcıda türetilmiş bir özellik ama happy-dom onu
   * özniteliğe göre doldurmuyor; sözleşme ÖZNİTELİK olduğu için ikisi de kontrol ediliyor.
   */
  if (target.isContentEditable) return true;
  const attr = target.getAttribute("contenteditable");
  return attr !== null && attr !== "false";
}
